import { __assign, __extends, __rest } from "tslib";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { Icon } from '@skbkontur/react-ui/internal/icons/20px';
import { createPropsGetter } from '@skbkontur/react-ui/lib/createPropsGetter';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { jsStyles } from './TopBar.styles';
import { ThemeFactory } from '@skbkontur/react-ui/lib/theming/ThemeFactory';
import { CommonWrapper } from '@skbkontur/react-ui/internal/CommonWrapper';
/**
 * Статичный элемент топбара
 *
 * @visibleName TopBar.StaticItem
 */
var TopBarItem = /** @class */ (function (_super) {
    __extends(TopBarItem, _super);
    function TopBarItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = createPropsGetter(TopBarItem.defaultProps);
        return _this;
    }
    TopBarItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = getAddonsTheme(theme);
            return React.createElement(ThemeContext.Provider, { value: _this.theme }, _this.renderMain());
        }));
    };
    TopBarItem.prototype.renderMain = function () {
        var _a, _b;
        var _c = this.props, active = _c.active, children = _c.children, _onClick = _c._onClick, _onKeyDown = _c._onKeyDown, iconOnly = _c.iconOnly, icon = _c.icon, minWidth = _c.minWidth, use = _c.use, rest = __rest(_c, ["active", "children", "_onClick", "_onKeyDown", "iconOnly", "icon", "minWidth", "use"]);
        var className = this.getProps().className;
        var classes = cn((_a = {},
            _a[jsStyles.item(this.theme)] = true,
            _a[jsStyles.buttonActive(this.theme)] = !!active,
            _a[jsStyles.usePay(this.theme)] = use === 'pay',
            _a[jsStyles.useDanger(this.theme)] = use === 'danger',
            _a[className] = true,
            _a));
        var iconClasses = cn((_b = {},
            _b[jsStyles.icon(this.theme)] = !!icon,
            _b[jsStyles.iconOnly()] = !!iconOnly,
            _b));
        var iconNode = typeof icon === 'string' ? React.createElement(Icon, { name: icon }) : icon;
        var variablesForActiveUserAvatar = active
            ? {
                addonsUserAvatarBackground: this.theme.addonsUserAvatarActiveBackground,
                addonsUserAvatarColor: this.theme.addonsUserAvatarActiveColor,
            }
            : {};
        return (React.createElement(ThemeContext.Provider
        // TODO: Убрать после решения проблемы с созданием темы
        , { 
            // TODO: Убрать после решения проблемы с созданием темы
            value: ThemeFactory.create(variablesForActiveUserAvatar, this.theme) },
            React.createElement(CommonWrapper, __assign({}, this.props),
                React.createElement("div", __assign({}, rest, { className: classes, onClick: _onClick, onKeyDown: _onKeyDown, style: { minWidth: minWidth } }),
                    icon && React.createElement("span", { className: iconClasses }, iconNode),
                    icon && iconOnly ? null : children))));
    };
    TopBarItem.__KONTUR_REACT_UI__ = 'TopBarItem';
    TopBarItem.propTypes = {
        use: PropTypes.oneOf(['danger', 'pay', 'default']),
    };
    TopBarItem.defaultProps = {
        className: '',
        use: 'default',
    };
    return TopBarItem;
}(React.Component));
export { TopBarItem };
